/* eslint-disable */

import * as runtime from '../runtime';
import type {
  TurnstileConfigDto,
} from '../models';


export class TurnstileApi extends runtime.BaseAPI {

  async getTurnstileConfig(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TurnstileConfigDto> {
    const response = await this.request({ path: '/integrations/turnstile/config', method: 'GET', headers: {}, query: {} }, initOverrides);
    return response.json();
  }

}
